import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { currentApplicationSelector } from '../../store/application'
import { Button, Form, Modal, message, Select, Space, Typography, Input } from 'antd'
import { createRefundItem } from '../../services/refund'
import { formatDecimalAmount } from '../../utils/number-utils'

const { Text } = Typography

const RefundInfo = ({ item }) => {
  if (!item) {
    return null
  }

  const amount = item?.actualAmount !== null ? item?.actualAmount : item.amount
  const refund = item?.refund_items?.reduce((acc, refund) => acc + refund.amount, 0)

  return (
    <div style={{ paddingLeft: 8, paddingBottom: 8 }}>
      <Text>Оставшееся количество с учетом возвратов: </Text>
      <Text strong>{formatDecimalAmount(amount - refund)}</Text>
      <Text strong>{item.unit}</Text>
    </div>
  )
}

const RefundModal = ({ showModal, onClose, onSuccess }) => {
  const [form] = Form.useForm()
  const implementationItem = Form.useWatch('implementation', form)
  const currentApplication = useSelector(currentApplicationSelector)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const options = currentApplication?.implementation?.implementation_items.map((item) => ({
    label: `${item.name} (кол-во: ${formatDecimalAmount(
      item?.actualAmount !== null ? item?.actualAmount : item.amount
    )} ${item.unit})`,
    value: item.id,
  }))

  const getImplementationItemById = (id) =>
    currentApplication?.implementation?.implementation_items?.find((item) => item.id === id)

  useEffect(() => {
    setSelectedItem(getImplementationItemById(implementationItem))
  }, [implementationItem])

  const onFormSubmit = async (values) => {
    setIsLoading(true)
    const implementationItem = getImplementationItemById(values.implementation)
    const applicationItem = currentApplication?.application_items?.find(
      (item) => item.id === implementationItem?.application_item?.id
    )
    try {
      await createRefundItem({
        data: {
          amount: values.amount,
          reason: values.reason,
          implementationItem: values.implementation,
          applicationItem: {
            name: applicationItem?.name,
            description: applicationItem?.description,
            unit: applicationItem?.unit,
            amount: values.amount,
            estimate_field: applicationItem?.estimate_field?.id,
            category: applicationItem?.category,
            off_budget: applicationItem?.off_budget,
            project: applicationItem?.project?.id,
          },
        },
      })
      form.resetFields()
      if (onSuccess) {
        onSuccess()
      }

      onClose()
      message.success('Возврат успешно создан')
    } catch (error) {
      message.error('Ошибка при создании возврата')
    } finally {
      setIsLoading(false)
    }
  }

  const onCloseHandler = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title="Новый возврат"
      visible={showModal}
      onCancel={onCloseHandler}
      footer={[
        <Button key="back" onClick={onCloseHandler} disabled={isLoading}>
          Отмена
        </Button>,
        <Button key="agree" onClick={() => form.submit()} disabled={isLoading}>
          Сохранить
        </Button>,
      ]}
    >
      <Form name="refund" layout="vertical" form={form} onFinish={onFormSubmit} initialValues={{}}>
        <Form.Item
          style={{ minWidth: 350 }}
          label="Позиция из заявки"
          name="implementation"
          rules={[{ required: true, message: 'Поле обязательно' }]}
        >
          <Select options={options} style={{ minWidth: 350 }} dropdownMatchSelectWidth={false} />
        </Form.Item>
        <Space size={0}>
          <RefundInfo item={selectedItem} />
        </Space>
        <Form.Item label="Количество возврата" name="amount" rules={[{ required: true, message: 'Поле обязательно' }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Причина возврата" name="reason" rules={[{ required: true, message: 'Поле обязательно' }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default RefundModal
